import React, { Component } from "react";
import { Form, Layout, Row, Col } from "antd";
import "./index.scss";
import { RandomReveal } from 'react-random-reveal';
import DOMPurify from "dompurify";
import moment from "moment";

const { Content } = Layout;

class RaffleViewer extends Component {
  initialState = {
    rSettingsData: null,
    eventData: {},
    currentPage: '',
    previousPage: '',
    previousPrize: null,
    currentWinner: null,
    previousWinner: null,
    isRequesting: false,
    settings: {}
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  getData = async () => {
    if (this.props.eventData.id && !this.state.isRequesting) {
      this.setState({
        isRequesting: true,
      });
      const currentPage = this.state.currentPage;
      const winner = this.state.currentWinner;
      const onGetParam = {
        event_id: this?.props?.eventData?.id,
      };

      if (currentPage.toLowerCase() == "prize") {
        const prize = this.state.rSettingsData[3] ? JSON.parse(this.state.rSettingsData[3]?.value) : {};
        this.setState({
          previousPrize: prize.prize_image,
          previousWinner: null,
          currentWinner: null,
        });
      }
      if (currentPage.toLowerCase() == 'winner') {
        this.setState({
          previousWinner: winner,
          previousPrize: null
        });
      }
      this.setState({
        previousPage: currentPage,
      });

      await this.props.onGetSettings(onGetParam);

      this.setState({
        isRequesting: false,
      });
    }

    setTimeout(this.getData, 4000);

  }

  async componentDidMount() {
    const eventName = this.props.match.params.event;
    const params = {
      slug: eventName
    };
    await this.props.onGetEventBySlug(params);

    await this.getData()
    // setInterval(() => this.getData(), 100000);
  }

  async componentWillReceiveProps(nextProps) {
    if (this.props.rSettingsData !== nextProps.rSettingsData) {
      const showPage = nextProps.rSettingsData.data[1]?.value
      const winner = JSON.stringify(nextProps.rSettingsData?.data[2]?.value)
      const settings = {};

      if (nextProps.rSettingsData.data) {
        // console.log("row", nextProps.rSettingsData.data)
        nextProps.rSettingsData.data.forEach(row => {
          // console.log("row", row)
          settings[row.name] = row.value;
          if (!Array.isArray(row.value)) {
            // console.log("row.value", row.value)
            try {
              settings[row.name] = JSON.parse(row.value);
            } catch (e) {
              // console.log("Error Parsing: ", e);
              settings[row.name] = row.value;
            }
          }
        });
      }

      // console.log("settings: ", settings);

      this.setState({
        rSettingsData: nextProps.rSettingsData.data,
        eventData: nextProps.rSettingsData.event_page_details,
        currentPage: showPage,
        currentWinner: winner,
        settings: settings
      });


    }
  }

  render() {
    const { rSettingsData, eventData, previousPage, previousPrize, currentPage, previousWinner, currentWinner, settings } = this.state
    const { isLoading, } = this.props;

    if (!rSettingsData) {
      return '';
    }

    const showPage = rSettingsData[1]?.value
    const showWinner = rSettingsData[2]?.value
    const showPrize = rSettingsData[3] && JSON.parse(rSettingsData[3]?.value)

    let pageSettings = {};
    let prize = null;
    let winner = null;
    rSettingsData.forEach(row => {
      if (row.name == showPage.toLowerCase().replace(' ', '_') + "_page") {
        pageSettings = row.value;
      }

      if (row.name == "prize") {
        prize = JSON.parse(row.value);
      }

      if (row.name == "winner") {
        winner = row.value;
      }
    });

    // console.log("prize:", prize)

    console.log("rSettingsData", rSettingsData)
    console.log("eventData", eventData)
    console.log("settings", settings)



    let pageContent = pageSettings.content;
    if (prize) {
      pageContent = pageContent.replace("{{prize-name}}", prize.label);
      pageContent = pageContent.replace("{{prize-category}}", prize.name);
      pageContent = pageContent.replace("{{prize-image}}", `<img class='prize-image' src='${process.env.REACT_APP_S3_BUCKET}${prize.prize_image}?${previousPrize != prize.prize_image ? moment().format('x') : ''}' />`);
      pageContent = pageContent.replace("{{prize-description}}", prize.description);
    }

    if (winner) {
      pageContent = pageContent.replace("{{winner}}", '');
    }

    console.log("showPage.toLowerCase()", showPage.toLowerCase());
    const sanitizeContent = DOMPurify.sanitize(pageContent);

    return (
      <Layout className="raffle-viewer-container"
        style={{
          backgroundColor: pageSettings.background_color ?? '',
          backgroundImage: pageSettings.background_color ? 'url("' + process.env.REACT_APP_S3_BUCKET + pageSettings.background_image + '")' : '',
          height: "100vh",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "auto auto"
        }}>
        <Content>
          <Row type="flex" gutter={30} align="middle" style={{ height: "100%" }}>
            {/* <Col span={24} height={"100%"} className="roboto-black" dangerouslySetInnerHTML={{ __html: sanitizeContent }} /> */}
            <Col span={24} className="roboto-black"
              style={{
                color: "white", display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}>

              {
                showPage.toLowerCase() === 'blank' ?
                  <Col span={20} align="center"
                    style={{
                      fontSize: '15rem',
                      lineHeight: '13rem',
                      textAlign: 'center',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      textTransform: 'capitalize'
                    }}>
                    {eventData.event_slug.toLowerCase().replace(/-/g, " ")}
                  </Col>
                  : null
              }

              {
                showPage.toLowerCase() === 'splash' ?
                  <Col span={20} align="center"
                    style={{
                      fontSize: '15rem',
                      lineHeight: '13rem',
                      textAlign: 'center',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      textTransform: 'uppercase'
                    }}>
                    {settings.prize.name}
                  </Col>
                  : null
              }

              {
                showPage.toLowerCase() === 'prize' ?
                  <Col span={20} align="center"
                    style={{
                      fontSize: '15rem',
                      lineHeight: '10rem',
                      textAlign: 'center',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      textTransform: 'uppercase'
                    }}>
                    <div style={{ fontSize: '5rem', ineHeight: '3rem', textTransform: "none" }}>{settings.prize.draw_count} {settings.prize.draw_count > 1 ? "Winners" : "Winner"} of</div>
                    <div>{settings.prize.label}</div>
                  </Col>
                  : null
              }

              {
                showPage.toLowerCase() === 'winner' ?
                  <Col span={20} align="center"
                    style={{
                      fontSize: '6rem',
                      lineHeight: '6rem',
                      textAlign: 'center',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      textTransform: 'uppercase'
                    }}>
                    <Row type="flex">
                      <Col span={10} style={{
                        display: 'inline-flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%'
                      }}>
                        <div style={{
                          display: 'inline-block',
                          verticalAlign: 'middle',
                        }}>
                          <div style={{ fontSize: '5rem', ineHeight: '3rem', textTransform: "none" }}>{settings.prize.draw_count} {settings.prize.draw_count > 1 ? "Winners" : "Winner"} of</div>
                          <div>{settings.prize.label}</div>
                        </div>
                      </Col>

                      <Col span={14}>
                        {settings.winner.length <= 5 ?
                          <div>
                            {settings.winner.map((row, index) => {
                              return (
                                <div style={{ fontSize: "4rem", lineHeight: "4rem", color: "navy", backgroundColor: "white", padding: "10px", borderRadius: "10px", margin: "10px" }} key={index}>
                                  <RandomReveal isPlaying duration={1.5} characters={row} />
                                </div>
                              )
                            })}
                          </div>
                          : null
                        }
                      </Col>
                    </Row>
                    {/* <div style={{ fontSize: '5rem', ineHeight: '3rem', textTransform: "none" }}>{settings.prize.draw_count > 1 ? "Winners" : "Winner"} of {settings.prize.label}</div> */}
                    {/* <div>
                      {settings.winner.map(row => {
                        return <Col span={settings.winner.length > 5 ? 12 : 24} style={settings.winner.length > 5 ? { fontSize: '4rem', lineHeight: '4rem', } : { fontSize: '6rem', lineHeight: '6rem', }}>{row}</Col>
                      })}
                    </div> */}
                  </Col>
                  : null
              }

              {
                showPage.toLowerCase() === 'thank you' ?
                  <Col span={20} align="center"
                    style={{
                      fontSize: '6rem',
                      lineHeight: '6rem',
                      textAlign: 'center',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      textTransform: 'uppercase'
                    }}>
                    <div style={{ fontSize: '5rem', ineHeight: '3rem', textTransform: "none" }}>{settings.prize.draw_count > 1 ? "Winners" : "Winner"} of {settings.prize.label}</div>
                    <div>
                      {settings.winner.map(row => {
                        return <Col span={settings.winner.length > 5 ? 12 : 24} style={settings.winner.length > 5 ? { fontSize: '4rem', lineHeight: '4rem', } : { fontSize: '6rem', lineHeight: '6rem', }}>{row}</Col>
                      })}
                    </div>
                  </Col>
                  : null
              }

            </Col>
            {/* {showPage.toLowerCase() === 'winner' ?
              <Col span={24} align="center">
                {winner.map((row, index) => {
                  if (previousWinner == currentWinner) {
                    return (<div style={{ fontSize: "4rem" }} key={index}>{row}</div>)
                  }

                  return (
                    <div style={{ fontSize: "4rem" }} key={index}>
                      <RandomReveal isPlaying duration={1.5} characters={row} />
                    </div>
                  );
                })}
              </Col> : null} */}
          </Row>
        </Content>
      </Layout >
    );
  }
}

const RaffleViewerForm = Form.create({ name: "raffle-viewer-form" })(RaffleViewer);

export default RaffleViewerForm;
